import React from 'react';
import PropTypes from 'prop-types';

//styles
import { TextArea } from './TextArea.styled';

const TextAreaInput = ({
  name,
  error,
  rows,
  disabled,
  placeholder,
  readOnly,
  margin,
  onInput,
  autoResize,
}) => {
  return (
    <TextArea
      component="textarea"
      rows={rows || '10'}
      name={name}
      error={error ? 'hasError' : 'noError'}
      disabled={disabled}
      placeholder={placeholder}
      readOnly={readOnly}
      margin={margin}
      onInput={onInput}
      $autoResize={autoResize}
    />
  );
};

TextAreaInput.propTypes = {
  name: PropTypes.string.isRequired,
  error: PropTypes.bool,
  rows: PropTypes.number,
  disabled: PropTypes.bool,
  placeholder: PropTypes.string,
  readOnly: PropTypes.bool,
  margin: PropTypes.string,
  onInput: PropTypes.func,
  autoResize: PropTypes.bool,
};

export default TextAreaInput;
